import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { dispatchUpdateSyncStatus } from "../../store/sync-store";
import { dispatchRethinkDBLogs, dispatchServerAppLogs } from "../../store";
import SyncStatus from "../../enums/syncStatus";
import constants from "../../globalization";
import { TimeConstants } from "../../constants";
import {
  LogLevelEnum,
  socketTypes,
  SubscriberEnum,
} from "../../enums";
import { getPopupConfig } from "../../components/Popup";
import DBManager from "../../services/db-manager";
import EventEmitter from '../../util/event-emitter';
import { SocketProvider } from './SocketContext';
import { version } from '../../../package.json';
import Popup from '../../components/Popup/Popup';
import PopupContent from '../../components/Popup/PopupContent';
import { updateNotification } from "../../store/actions/notification";
import FireboardUtils from "../../util/fireboard-util";
import API from "../../requests";
import { MdmPopup, DevicePopup } from './Popup';
import UTILLib from "../../util";
import moment from "moment";
import { addPrintLog as addPrintLogAction } from "../../store/actions";
import CApiWebSocketService from "../../CApiWebSocket/CApiWebSocketService";
import cApiWebSocketSubscriberEnum from "../../enums/cApiWebSocketSubscriberEnum";
import pako from 'pako';
import useAsyncState from "../../hooks/useAsyncState";

const SocketContextComponent = props => {
  const [connected, setConnected] = useState(false);
  const [popup, setPopup] = useState(undefined);
  const [checks, setChecks] = useAsyncState(new Map());
  const [bookings, setBookings] = useAsyncState(new Map());
  const [newNotifications, setNewNotifications] = useAsyncState([]);
  const [mdmPolicyNotification, setMdmPolicyNotification] = useState(undefined);
  const [errorOrderFlag, setErrorOrderFlag] = useState(false);
  const [defaultDeviceTypeId, setDeviceType] = useState(0);
  const [isTblDeliveryMounted, setIsTblDeliveryMounted] = useState(false);
  const [multipleStores, setMultipleStores] = useAsyncState([]);
  const [fbVenueMode, setFbVenueMode] = useAsyncState(false);
  const [venueInfo, setVenueInfo] = useAsyncState({});
  const [startMDMTimer, setStartMDMTimer] = useState(false);
  const [isMultiPrint, setIsMultiPrint] = useState(false);
  const [notificationToBeAck, setNotificationToBeAck] = useState(null);
  const [subscribers, setSubscribers] = useState({
    systemChannel: null,
    storeCheck: null,
    multiStoreCheck: new Map(),
    storeNotification: null,
    multiStoreNotification: new Map(),
  });
  const [newChecks, setNewChecks] = useAsyncState(new Map());
  const [isDashboardMounted, setIsDashboardMounted] = useState(false);

  const storeInfo = useSelector(state => state?.storeInfo?.data);
  const deviceApi = useSelector(state => state?.deviceApi?.data);
  const componentState = useSelector(state => state?.componentState);
  const notifications = useSelector(state => state?.notifications);
  const checkSortReducer = useSelector(state => state?.checkSortReducer?.data);
  const notificationsRef = useRef();
  const checkSettingsRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    notificationsRef.current = notifications;
  }, [notifications]);

  useEffect(() => {
    checkSettingsRef.current = checkSortReducer;
  }, [checkSortReducer]);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.sendAppMode(version);
    }
  }, []);

  useEffect(() => {
    return () => {
      subscribers.systemChannel && subscribers.systemChannel();
      subscribers.storeCheck && subscribers.storeCheck();
      subscribers.storeNotification && subscribers.storeNotification();
      subscribers.multiStoreCheck.forEach((subscriber) => {
        subscriber && subscriber();
      });
      subscribers.multiStoreNotification.forEach((subscriber) => {
        subscriber && subscriber();
      });
      emitSyncLogs(LogLevelEnum.WARN, `Unsubscribed all Rethink Listeners...`);
    };
  }, []);

  useEffect(() => {
    if (!FireboardUtils.isObjectBlank(storeInfo) && !FireboardUtils.isObjectBlank(deviceApi)) {
      const { id: storeId, deviceTypeId, cachingProvider, syncWebSocketHostname, syncApiKey } = storeInfo || {};
      const { venueMode, deviceGroup } = deviceApi || {};
      if (!connected) {
        const isDeviceGroupNull = FireboardUtils.isObjectBlank(deviceGroup);
        let fbVenueModeEnabled = false;
        if (!isDeviceGroupNull && deviceGroup?.startMode === 6 && (defaultDeviceTypeId === 15 || deviceTypeId === 15)) {
          setFbVenueMode(true);
          fbVenueModeEnabled = true;
        }
        EventEmitter.addLogs('appLogs', LogLevelEnum.INFO, `Venue Mode is ${venueMode} and deviceTypeId id ${deviceTypeId}`);
        if ((venueMode && (defaultDeviceTypeId === 13 || deviceTypeId === 13)) || fbVenueModeEnabled) {
          setIsMultiPrint(true);
          getVenueInfo();
        } else {
          if (cachingProvider) {
            connectToCApiWebSocket();
          } else {
            connectToYApiWebSocket(syncWebSocketHostname, storeId, syncApiKey);
          }
        }
        setConnected(true);
      }
    }
  }, [storeInfo, deviceApi]);

  useEffect(() => {
    checkAndApplyMDMPolicy();
  }, [componentState]);

  const getVenueInfo = () => {
    const { deviceId } = deviceApi || {};
    const { cachingProvider } = storeInfo || {};
    API.getVenueInfo(deviceId)
      .then(response => {
        FireboardUtils.addNetworkLogs(response);
        const stores = response.data.saStoreInfos;
        setMultipleStores(stores);
        const { id, name } = response.data;
        setVenueInfo({ id, name });
        if (window.ReactNativeWebView) {
          EventEmitter.sendVenueInfo(name);
        }
        //if no stores returned - display a popup with error message
        //on press OK - exit the app if it is launched as REACT NATIVE WEB VIEW else simply close the popup
        if (Array.isArray(stores) && stores.length === 0) {
          const popup = getPopupConfig("error");
          popup.message = "Venue locations not setup. Please configure locations on the portal";
          popup.buttons = [{
            text: constants.ok,
            onClick: () => {
              if (window.ReactNativeWebView)
                EventEmitter.restartApp();//post an event to close app
              else
                setPopup(undefined);
            },
          }];
          setPopup(popup);
        }

        const firstStore = stores.length > 0 ? stores[0] : {};
        if (cachingProvider) {
          connectToCApiWebSocket();
        } else {
          connectToYApiWebSocket(firstStore?.syncWebSocketHostname, firstStore?.id, firstStore?.syncApiKey);
        }
      }).catch(error => {
        FireboardUtils.addNetworkLogs(error.response);
        const errorMsg = error.response
          ? error.response.data.message
          : error.message;
        getPopup("error", null, errorMsg);
      });
  };

  //connect to CApiWebSocket and subcribe to checks & notifications updates
  const connectToCApiWebSocket = () => {
    const { deviceExternalId, apiKey } = deviceApi || {};
    const { id: storeId, deviceTypeId, cApiHostname } = storeInfo || {};
    if (fbVenueMode.current) {
      getVenueChecksCApi();
    } else {
      getStoreChecksCApi();
    }
    getStoreNotificationsCApi();
    getStoreBookingsCApi();
    const cApiWebSocketService = new CApiWebSocketService(storeId, deviceTypeId);
    cApiWebSocketService.connect(cApiHostname, apiKey, deviceExternalId, cApiWebSocketSubscriber);
  };

  const cApiWebSocketSubscriber = (message) => {
    if (message.messageType === cApiWebSocketSubscriberEnum.CheckAdded ||
      message.messageType === cApiWebSocketSubscriberEnum.CheckUpdated ||
      message.messageType === cApiWebSocketSubscriberEnum.CheckDeleted ||
      message.messageType === cApiWebSocketSubscriberEnum.ChecksCleared
    ) {
      handleCApiChecksSubscription(message);
    } else if (message.messageType === cApiWebSocketSubscriberEnum.NotificationAdded ||
      message.messageType === cApiWebSocketSubscriberEnum.NotificationUpdated ||
      message.messageType === cApiWebSocketSubscriberEnum.NotificationDeleted ||
      message.messageType === cApiWebSocketSubscriberEnum.NotificationsCleared
    ) {
      handleCApiNotificationSubscription(message);
    } else if (message.messageType === cApiWebSocketSubscriberEnum.BookingAdded ||
      message.messageType === cApiWebSocketSubscriberEnum.BookingUpdated ||
      message.messageType === cApiWebSocketSubscriberEnum.BookingDeleted ||
      message.messageType === cApiWebSocketSubscriberEnum.BookingsCleared
    ) {
      handleCApiBookingsSubscription(message);
    }

    //dispatch logs
    dispatchServerAppLogs(
      LogLevelEnum.INFO,
      `New Message has been received from CApiWebSocket. The type of the message - ${message.messageType} & the store id this message is intended for ${message.storeId}`
    );
    emitSyncLogs(
      LogLevelEnum.INFO,
      `New Message has been received from CApiWebSocket. The type of the message - ${message.messageType} & the store id this message is intended for ${message.storeId}`
    );
  };

  const handleCApiChecksSubscription = message => {
    const { deviceTypeId, serverAppFeatures } = storeInfo || {};
    const { supportsPrintRouting = false } = serverAppFeatures || {};

    let storeName = '';
    if (isMultiPrint || fbVenueMode.current) {
      const store = multipleStores.current.find(store => store.id === message?.storeId);
      storeName = store?.name || '';
    } else {
      storeName = storeInfo?.name;
    }

    //handing check subscription
    let copiedChecks = new Map(checks.current);
    let copiedNewChecks = new Map(newChecks.current);
    switch (message.messageType) {
      //check was added or updated
      case cApiWebSocketSubscriberEnum.CheckAdded:
      case cApiWebSocketSubscriberEnum.CheckUpdated: {
        const { checkHeaderId, checkHeader } = message;
        const orderTypeName = getOrderTypeName(checkHeader.orderTypeId);
        const revenueCenterName = getRevenueCenterName(checkHeader.revenueCenterId);
        const existingCheck = copiedChecks.get(checkHeaderId);
        let updatedCheck = {};
        if (existingCheck) {
          const deliverToChanged = FireboardUtils.getDeliverTo(existingCheck) !== FireboardUtils.getDeliverTo(checkHeader);
          const paidAmountChanged = existingCheck.paidAmount !== checkHeader.paidAmount;
          updatedCheck = {
            ...checkHeader,
            storeName: storeName || '',
            storeId: message?.storeId,
            orderTypeName,
            revenueCenterName,
            isNew: existingCheck?.isNew || false,
            paidAmountChanged: existingCheck?.paidAmountChanged || paidAmountChanged,
            deliverToChanged: existingCheck?.deliverToChanged || deliverToChanged,
            printStatus: existingCheck?.printStatus || '',
          };
          if (defaultDeviceTypeId === 13 || deviceTypeId === 13 || ((defaultDeviceTypeId === 15 || deviceTypeId === 15) && supportsPrintRouting)) {
            print(updatedCheck);
          }
        } else {
          updatedCheck = {
            ...checkHeader,
            storeName: storeName || '',
            orderTypeName,
            revenueCenterName,
            isNew: true,
            storeId: message?.storeId,
          }
          print(updatedCheck);
        }
        copiedChecks.set(checkHeaderId, updatedCheck);
        if (isDashboardMounted) {
          copiedNewChecks.set(checkHeaderId, { ...updateCheck, capiMessageType: existingCheck ? 'updated' : 'new' });
          setNewChecks(copiedNewChecks);
        }
        checkForErrorOrder(checkHeader);
        break;
      }
      //check was deleted
      case cApiWebSocketSubscriberEnum.CheckDeleted: {
        const { checkHeaderId } = message;
        if (isDashboardMounted) {
          copiedNewChecks.set(checkHeaderId, { ...copiedChecks.get(checkHeaderId), capiMessageType: 'deleted' });
          setNewChecks(copiedNewChecks);
        }
        copiedChecks.delete(checkHeaderId);
        break;
      }
      //all checks for the store were cleared/deleted
      case cApiWebSocketSubscriberEnum.ChecksCleared: {
        copiedChecks = new Map();
        break;
      }
      default:
        console.info('No check subscription!');
        break;
    }
    //update checks
    setChecks(copiedChecks);
  };

  const handleCApiNotificationSubscription = message => {
    //handling notification subscription
    const tempNotifications = [...notificationsRef.current];
    switch (message.messageType) {
      //notification was added or updated
      case cApiWebSocketSubscriberEnum.NotificationAdded:
      case cApiWebSocketSubscriberEnum.NotificationUpdated: {
        const { deviceId: currentDeviceId } = deviceApi || {};
        const { notification } = message;
        const { deviceId: nDeviceId, notificationTypeId } = notification;
        if (notificationTypeId === 20 && nDeviceId === currentDeviceId) {
          if (window.ReactNativeWebView) {
            EventEmitter.playAudio(true);
          }
          setNotificationToBeAck(getModifiedNotification(notification));
          setPopup({ type: 'device', metaData: { note: notification.note } });
        } else if (notificationTypeId === 19) {
          setNotificationToBeAck(getModifiedNotification(notification));
          setMdmPolicyNotification(getModifiedNotification(notification));
          checkAndApplyMDMPolicy();
        } else if (notificationTypeId === 15) {
          handleEODNotification();
        } else {
          let copiedNotifications = [...newNotifications.current];
          //modified the notification object to make compatiable with yapi notification
          copiedNotifications.push({
            type: 'update',
            value: getModifiedNotification(notification),
          });
          setNewNotifications(copiedNotifications);
        }
        break;
      }
      //notification was deleted
      case cApiWebSocketSubscriberEnum.NotificationDeleted: {
        const updatedNotifications = tempNotifications.filter(n => n.id !== message.notificationId) || [];
        dispatch(updateNotification(updatedNotifications));
        break;
      }
      //all notifications for the store were cleared/deleted
      case cApiWebSocketSubscriberEnum.NotificationsCleared: {
        dispatch(updateNotification([]));
        break;
      }
      default:
        console.info('No notification subscription!');
        break;
    }
  };

  const handleCApiBookingsSubscription = message => {
    //handling bookings subscription
    let copiedBookings = new Map(bookings.current);
    switch (message.messageType) {
      case cApiWebSocketSubscriberEnum.BookingAdded: //Booking was added
      case cApiWebSocketSubscriberEnum.BookingUpdated: { //Booking was updated
        const { bookingId, booking } = message;
        copiedBookings.set(bookingId, booking);
        break;
      }
      case cApiWebSocketSubscriberEnum.BookingDeleted: { //Booking was deleted
        const { bookingId } = message;
        copiedBookings.delete(bookingId);
        break;
      }
      case cApiWebSocketSubscriberEnum.BookingsCleared: { //All bookings for the store were cleared / deleted
        copiedBookings = new Map();
        break;
      }
      default:
        console.info('No booking subscription!');
        break;
    }
    setBookings(copiedBookings);
  };

  //get all checks using CAPI websocket
  const getStoreChecksCApi = (callback) => {
    const { id: storeId, name: storeName } = storeInfo || {};
    API.getStoreChecks(storeId)
      .then(response => {
        try {
          const checksData = JSON.parse(decompressData(response.data.compressedData));
          let checks = new Map();
          checksData && checksData.forEach((check) => {
            check.orderTypeName = getOrderTypeName(check.orderTypeId);
            check.revenueCenterName = getRevenueCenterName(check.revenueCenterId);
            checks.set(check.id, { ...check, storeName: storeName || '', storeId });
          });
          emitSyncLogs(LogLevelEnum.INFO, `Response from get store checks. Total number of checks - ${checks.size}`);
          setChecks(checks);
          callback && callback();
        } catch (err) {
          console.error('error in CAPI get store checks - ', err);
        }
      })
      .catch(error => {
        dispatchServerAppLogs(LogLevelEnum.ERROR, "Get store checks errored out");
        emitSyncLogs(LogLevelEnum.ERROR, `Get store checks errored out. Store name - ${storeName} and store id - ${storeId}`);
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        getPopup("error", null, errorMsg);
      });
  };

  //if App started in venue mode - invoke endpoint to get all checks by passing venueId
  //the endpoint will return all checks for the venue
  const getVenueChecksCApi = (callback) => {
    API.getVenueChecks(venueInfo.current?.id)
      .then(response => {
        try {
          const checksData = JSON.parse(decompressData(response.data.compressedData));
          let checks = new Map();
          checksData && checksData.forEach((check) => {
            check.orderTypeName = getOrderTypeName(check.orderTypeId);
            check.revenueCenterName = getRevenueCenterName(check.revenueCenterId);
            const store = multipleStores.current.find(st => st.id === check.storeId);
            checks.set(check.id, { ...check, storeName: store?.name || '' });
          });
          emitSyncLogs(LogLevelEnum.INFO, `Response from get venue checks. Total number of checks - ${checks.size}`);
          setChecks(checks);
          callback && callback();
        } catch (err) {
          console.error('error in CAPI get store checks - ', err);
        }
      })
      .catch(error => {
        dispatchServerAppLogs(LogLevelEnum.ERROR, "Get venue checks errored out");
        emitSyncLogs(LogLevelEnum.ERROR, `Get venue checks errored out. Venue Id - ${venueInfo.current?.id}`);
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        getPopup("error", null, errorMsg);
      })
  };

  //get all notifications using CAPI websocket
  const getStoreNotificationsCApi = (callback) => {
    const { id: storeId } = storeInfo || {};

    API.getStoreNotifications(storeId)
      .then(response => {
        try {
          const notificationsData = JSON.parse(decompressData(response.data.compressedData));
          let notificationsMap = new Map();
          notificationsData && notificationsData.forEach((n) => {
            notificationsMap.set(n.id, n);
          });
          emitSyncLogs(LogLevelEnum.INFO, `Response from get all notification. Total number of notifications - ${notificationsMap.size}`);
          let allNotifications = Array.from(notificationsMap.values());
          allNotifications = allNotifications.filter(n => n.notificationTypeId !== 16); //remove notification of notificationTypeId 16
          allNotifications &&
            allNotifications.forEach((n) => {
              n.printStatus = n.notificationTypeId === 18 ? n.acknowledged ? "Printed" : "Not Printed" : "";
              n.notificationId = n.id;
              const allReduxNotification = notificationsRef.current;
              const existingNotification = allReduxNotification
                ? allReduxNotification.find((eachNotification) => eachNotification.notificationId === n.notificationId)
                : null;
              if (existingNotification) {
                n.isNew = existingNotification.isNew;
                n.isDismissed = existingNotification.isDismissed;
                n.notificationTimes = existingNotification.notificationTimes || new Date().toISOString();
              } else {
                n.isNew = false;
                n.isDismissed = false;
                n.notificationTimes = new Date().toISOString();
              }
            });
          dispatch(updateNotification(allNotifications));
          callback && callback();
        } catch (err) {
          console.error('error in CAPI get store notification - ', err);
        }
      })
      .catch(error => {
        dispatchServerAppLogs(LogLevelEnum.ERROR, "Get notifications errored out");
        emitSyncLogs(LogLevelEnum.ERROR, `Get all notifications errored out - ${JSON.stringify(error)}`);
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        getPopup("error", null, errorMsg);
      });
  };

  //get all bookings using CAPI websocket
  const getStoreBookingsCApi = callback => {
    const { id: storeId } = storeInfo || {};
    API.getStoreBookings(storeId)
      .then(response => {
        const bookingsArray = JSON.parse(decompressData(response.data.compressedData));
        let bookings = new Map();
        bookingsArray.forEach(booking => {
          bookings.set(booking.id, booking);
        });
        setBookings(bookings);
        callback && callback();
      })
      .catch(error => {
        dispatchServerAppLogs(LogLevelEnum.ERROR, "Get bookings errored out");
        emitSyncLogs(LogLevelEnum.ERROR, `Get all bookings errored out - ${JSON.stringify(error)}`);
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        getPopup("error", null, errorMsg);
      });
  };

  const decompressData = (compressedBase64String) => {
    //decode base64 (convert ascii to binary)
    const decodedData = atob(compressedBase64String);

    //convert binary string to character number array
    const compressedData = Array.from(decodedData).map(c => c.charCodeAt(0));

    //turn number array into byte array
    const binaryData = new Uint8Array(compressedData);

    //decompress byte array using pako
    //pako - zlib port to JavaScript, very fast
    //results are binary equal to well known zlib
    const decompressedBinaryData = pako.inflate(binaryData);

    //convert decompressed byte array to unicode string
    const decompressedString = Array.from(new Uint8Array(decompressedBinaryData)).map(b => String.fromCharCode(b)).join('');
    return decompressedString;
  };

  const connectToYApiWebSocket = (syncWebSocketHostname, storeId, syncApiKey) => {
    const { deviceExternalId, password } = deviceApi || {};

    dispatchUpdateSyncStatus(SyncStatus.DISCONNECTED);
    if (window.ReactNativeWebView) {
      EventEmitter.syncStatus(SyncStatus.DISCONNECTED);
      emitSyncLogs(LogLevelEnum.INFO, `Initial Sync Status ${SyncStatus.DISCONNECTED}`);
    }
    const syncTimeout = setTimeout(() => {
      clearTimeout(syncTimeout);
      emitSyncLogs(LogLevelEnum.INFO, `Re-try to connect to redis - storeId ${storeId}`);
      errorTryAgain(
        constants.rethinkConnectionError,
        () => {
          connectToYApiWebSocket(syncWebSocketHostname, storeId, syncApiKey);
        },
      );
    }, 100 * TimeConstants.SECOND);

    dispatchRethinkDBLogs(LogLevelEnum.INFO, constants.usingRedis);
    DBManager.setMode(socketTypes.SOCKET);
    DBManager.createWebSocket(
      {
        redisSocketHostname: syncWebSocketHostname,
      },
      () => {
        DBManager.initialize(
          {
            deviceExternalId,
            password,
            syncUrl: syncWebSocketHostname,
            storeId,
            syncApiKey,
          },
          (error, response) => {
            const onSuccess = () => {
              clearTimeout(syncTimeout);
              dispatchUpdateSyncStatus(SyncStatus.SOCKET);
              if (window.ReactNativeWebView) {
                EventEmitter.syncStatus(SyncStatus.SOCKET);
                emitSyncLogs(LogLevelEnum.INFO, `Socket connected, sync status ${SyncStatus.SOCKET}`);
              }
            };
            if (error) {
              console.warn("error in initialize", error);
              dispatchRethinkDBLogs(
                LogLevelEnum.ERROR,
                constants.rethinkConnectionError
              );
              emitSyncLogs(LogLevelEnum.ERROR, `error in socket initialize ${JSON.stringify(error)}`);
              errorTryAgain(constants.rethinkConnectionError, () => {
                connectToYApiWebSocket(syncWebSocketHostname, storeId, syncApiKey);
              });
              clearTimeout(syncTimeout);
            } else {
              console.debug("response from initializeRethinkDB", response);
              dispatchRethinkDBLogs("INFO", `Connected to ${DBManager.mode}`);
              emitSyncLogs(LogLevelEnum.INFO, `Connected to ${DBManager.mode}`);
              onSuccess && onSuccess();
              getDataFromRedis();
              subscribeToSystemChannel(storeId);
            }
          }
        );
      },
      () => {
        console.warn("websocket disconnected");
        dispatchRethinkDBLogs(
          "WARN",
          `Connection to ${DBManager.mode} is lost`
        );
        dispatchUpdateSyncStatus(SyncStatus.DISCONNECTED);
        if (window.ReactNativeWebView) {
          EventEmitter.syncStatus(SyncStatus.DISCONNECTED);
          emitSyncLogs(LogLevelEnum.ERROR, `Websocket disconnected, Connection to ${DBManager.mode} is lost`);
        }
      }
    );
  };

  const subscribeToSystemChannel = storeId => {
    subscribers.systemChannel && subscribers.systemChannel();

    const systemSubscriber = DBManager.subscribeToStore(
      storeId,
      (error, response) => {
        if (error) {
          dispatchRethinkDBLogs(
            LogLevelEnum.ERROR,
            "error subscribing to system channel"
          );
          console.warn("error subscribing to store channel", error);
          emitSyncLogs(LogLevelEnum.ERROR, `error subscribing to store channel ${JSON.stringify(error)}`);
        } else {
          console.debug("subscribed to system channel successfully", response);
          emitSyncLogs(LogLevelEnum.INFO, `subscribed to system channel successfully`);
        }
      },
      (res) => {
        switch (res.type) {
          case SubscriberEnum.DISCONNECT:
            break;
          default:
            console.info("case not handled");
        }
        emitSyncLogs(LogLevelEnum.INFO, `received message from system channel ${res.type}`);
        dispatchRethinkDBLogs(
          LogLevelEnum.INFO,
          `received message from system channel ${res.type}`
        );
      }
    );
    setSubscribers(state => {
      return {
        ...state,
        systemChannel: systemSubscriber,
      };
    });
  };

  const getDataFromRedis = () => {
    const { deviceTypeId } = storeInfo || {};
    if (defaultDeviceTypeId === 12 || deviceTypeId === 12) {
      getAllChecksYapi();
    } else {
      getAllChecksYapi();
    }
    getNotificationsYapi();
  };

  const getAllChecksYapi = () => {
    if (isMultiPrint) {
      multipleStores.current.forEach(s => {
        const sub = subscribers.multiStoreCheck.get(s.id);
        sub && sub();
        getStoreChecksYapi(s.id, s.name);
      });
    } else {
      const { id: storeId, name: storeName } = storeInfo || {};
      subscribers.storeCheck && subscribers.storeCheck();
      getStoreChecksYapi(storeId, storeName);
    }
  };

  const getStoreChecksYapi = (storeId, storeName) => {
    const checksCallback = (error, response) => {
      if (error) {
        dispatchServerAppLogs(
          LogLevelEnum.ERROR,
          "Get store checks errored out"
        );
        emitSyncLogs(LogLevelEnum.ERROR, `Get store checks errored out. Store name - ${storeName} and store id - ${storeId}`);
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        getPopup("error", null, errorMsg);
      } else {
        let checks = new Map();
        response.forEach((check) => {
          check.orderTypeName = getOrderTypeName(check.orderTypeId);
          check.revenueCenterName = getRevenueCenterName(check.revenueCenterId);
          checks.set(check.id, { ...check, storeName: storeName || '', storeId });
        });
        console.log("response from getallchecks", response, checks);
        emitSyncLogs(LogLevelEnum.INFO, `Response from get store checks. Total number of checks - ${checks.size}`);
        subscribeToCheckUpdates(storeId);
        setChecks(checks);
      }
    }
    DBManager.getStoreChecks(storeId, checksCallback);
  };

  const subscribeToCheckUpdates = (storeId) => {
    const callback = (error, response) => {
      if (error) {
        console.warn("error subscribing to check updates");
        dispatchUpdateSyncStatus(SyncStatus.DISCONNECTED);
        if (window.ReactNativeWebView) {
          EventEmitter.syncStatus(SyncStatus.DISCONNECTED);
          emitSyncLogs(LogLevelEnum.ERROR, `Error subscribing to check updates of storeId - ${storeId}`);
        }
        dispatchRethinkDBLogs(LogLevelEnum.ERROR, "checks sync error");
      } else {
        console.debug("employee check update", response);
        emitSyncLogs(LogLevelEnum.INFO, `Subscribed to check updates of storeId - ${storeId}`);
      }
    };

    const subscriber = (res, storeId) => {
      const { deviceTypeId, serverAppFeatures } = storeInfo || {};
      const { supportsPrintRouting = false } = serverAppFeatures || {};

      let storeName = '';
      if (isMultiPrint) {
        const storeDetails = multipleStores.current.filter(store => store.id === storeId);
        if (storeDetails && Array.isArray(storeDetails) && storeDetails.length > 0) {
          storeName = storeDetails[0]?.name;
        }
      } else {
        storeName = storeInfo?.name;
      }

      let copiedChecks = new Map(checks.current);

      switch (res.type) {
        case SubscriberEnum.INITIAL:
        case SubscriberEnum.CHANGE:
        case SubscriberEnum.UPDATE:
        case SubscriberEnum.ADD: {
          const orderTypeName = getOrderTypeName(res.value.orderTypeId);
          const revenueCenterName = getRevenueCenterName(res.value.revenueCenterId);
          const existingCheck = copiedChecks.get(res.value.checkHeaderId);
          let updatedCheck = {};
          if (existingCheck) {
            const deliverToChanged = FireboardUtils.getDeliverTo(existingCheck) !== FireboardUtils.getDeliverTo(res.value);
            const paidAmountChanged = existingCheck.paidAmount !== res.value.paidAmount;
            updatedCheck = {
              ...res.value,
              storeName: storeName || '',
              storeId: storeId,
              orderTypeName,
              revenueCenterName,
              isNew: existingCheck?.isNew || false,
              paidAmountChanged: existingCheck?.paidAmountChanged || paidAmountChanged,
              deliverToChanged: existingCheck?.deliverToChanged || deliverToChanged,
              printStatus: existingCheck?.printStatus || '',
            };
            copiedChecks.set(res.value.checkHeaderId, updatedCheck);
            if (defaultDeviceTypeId === 13 || deviceTypeId === 13 || ((defaultDeviceTypeId === 15 || deviceTypeId === 15) && supportsPrintRouting)) {
              print(updatedCheck);
            }
          } else {
            updatedCheck = {
              ...res.value,
              storeName: storeName || '',
              orderTypeName,
              revenueCenterName,
              isNew: true,
              storeId: storeId,
            };
            copiedChecks.set(res.value.checkHeaderId, updatedCheck);
            print(updatedCheck);
          }
          checkForErrorOrder(res.value);
          break;
        }

        case SubscriberEnum.REMOVE: {
          copiedChecks.delete(res.value.checkHeaderId);
          break;
        }
        case SubscriberEnum.DELETE: {
          res.value.forEach(({ checkHeaderId }) => {
            copiedChecks.delete(checkHeaderId);
          });
          break;
        }
        case SubscriberEnum.CLEAR: {
          copiedChecks = new Map();
          break;
        }
        default:
          console.warn('case not handled');
      }
      setChecks(copiedChecks);
      dispatchServerAppLogs(
        LogLevelEnum.INFO,
        `Check subscription - Id is ${res.value.checkHeaderId} and response type is ${res.type}`
      );
      emitSyncLogs(LogLevelEnum.INFO, `Check subscription - Check Id is ${res.value.checkHeaderId} and response type is ${res.type}`);
    };

    if (isMultiPrint) {
      const subscription = DBManager.subscribeToStoreChecks(
        storeId,
        callback,
        subscriber,
      );
      setSubscribers(state => {
        return {
          ...state,
          multiStoreCheck: state.multiStoreCheck.set(storeId, subscription),
        };
      });
    } else {
      const checkSubscriber = DBManager.subscribeToStoreChecks(
        storeId,
        callback,
        subscriber
      );
      setSubscribers(state => {
        return {
          ...state,
          storeCheck: checkSubscriber,
        };
      });
    }
  };

  const getNotificationsYapi = () => {
    const { id: storeId } = storeInfo || {};

    const callback = (error, response) => {
      if (error) {
        dispatchServerAppLogs(
          LogLevelEnum.ERROR,
          "Get notifications errored out"
        );
        emitSyncLogs(LogLevelEnum.ERROR, `Get all notifications errored out - ${JSON.stringify(error)}`);
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        getPopup("error", null, errorMsg);
      } else {
        console.info("all notification response", response);
        let notificationsMap = new Map();
        response && response.forEach((n) => {
          notificationsMap.set(n.id, n);
        });
        emitSyncLogs(LogLevelEnum.INFO, `Response from get all notification. Total number of notifications - ${notificationsMap.size}`);
        let allNotifications = Array.from(notificationsMap.values());
        allNotifications = allNotifications.filter(n => n.notificationTypeId !== 16); //remove notification of notificationTypeId 16
        allNotifications &&
          allNotifications.forEach((n) => {
            n.printStatus = n.notificationTypeId === 18 ? n.acknowledged ? "Printed" : "Not Printed" : "";
            n.notificationId = n.id;
            const allReduxNotification = notificationsRef.current;
            const existingNotification = allReduxNotification
              ? allReduxNotification.current.find((eachNotification) => eachNotification.notificationId === n.notificationId)
              : null;
            if (existingNotification) {
              n.isNew = existingNotification.isNew;
              n.isDismissed = existingNotification.isDismissed;
              n.notificationTimes = existingNotification.notificationTimes || new Date().toISOString();
            } else {
              n.isNew = false;
              n.isDismissed = false;
              n.notificationTimes = new Date().toISOString();
            }
          });
        dispatch(updateNotification(allNotifications));
      }
    }

    if (isMultiPrint) {
      multipleStores.current.forEach(s => {
        const sub = subscribers.multiStoreNotification.get(s.id);
        sub && sub();
        DBManager.getStoreNotifications(s.id, callback);
      });
      subscribeToNotifications();
    } else {
      subscribers.storeNotification && subscribers.storeNotification();
      DBManager.getStoreNotifications(storeId, callback);
      subscribeToNotifications();
    }
  };

  const subscribeToNotifications = () => {
    const { id: storeId } = storeInfo || {};
    const callback = (error, response) => {
      if (error) {
        dispatchServerAppLogs(
          LogLevelEnum.ERROR,
          "Notification subscription error"
        );
        dispatchUpdateSyncStatus(SyncStatus.DISCONNECTED);
        if (window.ReactNativeWebView) {
          EventEmitter.syncStatus(SyncStatus.DISCONNECTED);
          emitSyncLogs(LogLevelEnum.ERROR, `Notification subscription error`);
        }
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        getPopup("error", null, errorMsg);
      } else {
        console.debug("notificaton subscribtion response", response);
        emitSyncLogs(LogLevelEnum.INFO, `Subscribed to notification update`);
      }
    };

    const subscriber = (res) => {
      dispatchServerAppLogs(
        LogLevelEnum.INFO,
        `Notification subscription - Id is ${res.value.notificationId} and response type is ${res.type}`
      );
      emitSyncLogs(LogLevelEnum.INFO, `Notification subscription - Notification Id is ${res.value.notificationId} and response type is ${res.type}`);
      const tempNotifications = [...notificationsRef.current];
      switch (res.type) {
        case "add":
        case "initial":
        case "update":
        case "change": {
          console.info('new notification--', res);
          const { deviceId: currentDeviceId } = deviceApi || {};
          const { deviceId, notificationTypeId } = res?.value || {};
          if (notificationTypeId === 20 && deviceId === currentDeviceId) {
            if (window.ReactNativeWebView) {
              EventEmitter.playAudio(true);
            }
            const { note } = res.value || {};
            setNotificationToBeAck(getModifiedNotification(res.value));
            setPopup({ type: 'device', metaData: { note: note } });
          } else if (notificationTypeId === 19) {
            setNotificationToBeAck(getModifiedNotification(res.value));
            setMdmPolicyNotification(getModifiedNotification(res.value));
            checkAndApplyMDMPolicy();
          } else if (notificationTypeId === 15) {
            handleEODNotification();
          } else {
            let copiedNotifications = [...newNotifications.current];
            copiedNotifications.push(res);
            setNewNotifications(copiedNotifications);
          }
          break;
        }
        case "remove": {
          const notificationIndex = tempNotifications.findIndex(
            (notification) =>
              notification.notificationId === res.value.notificationId
          );
          if (notificationIndex !== -1) {
            tempNotifications.splice(notificationIndex, 1);
          }
          dispatch(updateNotification(tempNotifications));
          break;
        }
        case "delete": {
          res.value.forEach(({ notificationId }) => {
            const notificationIndex = tempNotifications.findIndex(
              (notification) =>
                notification.notificationId === parseInt(notificationId)
            );
            if (notificationIndex !== -1) {
              tempNotifications.splice(notificationIndex, 1);
            }
          });
          dispatch(updateNotification(tempNotifications));
          break;
        }
        default:
          console.info("notification type not handled", res.type);
      }
    };

    if (isMultiPrint) {
      multipleStores.current.forEach((s) => {
        emitSyncLogs(LogLevelEnum.INFO, `Subscribing to notification update - Store Id is ${s.id}`);
        const subscription = DBManager.subscribeToStoreNotifications(
          s.id,
          callback,
          subscriber
        );
        setSubscribers(state => {
          return {
            ...state,
            multiStoreNotification: state.multiStoreNotification.set(s.id, subscription),
          };
        });
      })
    } else {
      emitSyncLogs(LogLevelEnum.INFO, `Subscribing to notification update - Store Id is ${storeId}`);
      const notificationSubscriber = DBManager.subscribeToStoreNotifications(
        storeId,
        callback,
        subscriber
      );
      setSubscribers(state => {
        return {
          ...state,
          storeNotification: notificationSubscriber,
        };
      });
    }
  };

  const handleEODNotification = () => {
    setChecks(new Map());
    const { cachingProvider, id, name } = storeInfo || {};
    if (cachingProvider) {
      if (fbVenueMode.current) {
        getVenueChecksCApi();
      } else {
        getStoreChecksCApi();
      }
    } else {
      if (isMultiPrint) {
        multipleStores.current.forEach(store => {
          getAllChecksFromYApi(store.id, store.name);
        });
      } else {
        getAllChecksFromYApi(id, name);
      }
    }
  };

  const getAllChecksFromYApi = (storeId, storeName) => {
    const checksCallback = (error, response) => {
      if (error) {
        dispatchServerAppLogs(LogLevelEnum.ERROR, "Get store checks errored out");
        emitSyncLogs(LogLevelEnum.ERROR, `Get store checks errored out. Store name - ${storeName} and store id - ${storeId}`);
        const errorMsg = error.response ? error.response.data : error.message;
        getPopup("error", null, errorMsg);
      } else {
        let copiedChecks = new Map(checks.current);
        response.forEach((check) => {
          check.orderTypeName = getOrderTypeName(check.orderTypeId);
          check.revenueCenterName = getRevenueCenterName(check.revenueCenterId);
          copiedChecks.set(check.id, { ...check, storeName: storeName || '', storeId });
        });
        emitSyncLogs(LogLevelEnum.INFO, `Response from get store checks. Total number of checks - ${copiedChecks.size}`);
        setChecks(copiedChecks);
      }
    };
    DBManager.getStoreChecks(storeId, checksCallback);
  };

  const errorTryAgain = (error, callback) => {
    const popup = getPopupConfig("error");
    popup.message = error;
    popup.buttons = [];
    popup.buttons.push({
      text: constants.retry,
      onClick: () => {
        setPopup(undefined);
        callback && callback();
      },
    });
    setPopup(popup);
  };

  const acknowledgeCheck = checkHeaderId => {
    let copiedChecks = new Map(checks.current);
    const existingCheck = copiedChecks.get(checkHeaderId);
    if (existingCheck && (existingCheck.isNew || existingCheck.paidAmountChanged || existingCheck.deliverToChanged)) {
      copiedChecks.set(checkHeaderId, {
        ...existingCheck,
        isNew: false,
        paidAmountChanged: false,
        deliverToChanged: false,
      });
      setChecks(copiedChecks);
    }
  };

  const updateCheck = check => {
    const { id: storeId, name: storeName } = storeInfo || {};
    let copiedChecks = new Map(checks.current);
    if (check) {
      copiedChecks.set(check.id, { ...check, storeName: storeName || '', storeId });
      setChecks(copiedChecks);
    }
  };

  const checkForErrorOrder = check => {
    //check for error order
    if (!errorOrderFlag) {
      const { viewErrorOrders } = checkSettingsRef.current;
      let showErrorOrder = viewErrorOrders;

      //if device group data is not null then override value of "showErrorOrder" with "deviceGroup.fireBoardSettings.displayErrorOrderWarning" value
      const { deviceGroup } = deviceApi || {};
      if (!FireboardUtils.isObjectBlank(deviceGroup)) {
        const { fireBoardSettings } = deviceGroup || {};
        showErrorOrder = fireBoardSettings?.displayErrorOrderWarning;
      }

      if (showErrorOrder) {
        const { orders } = check || {};
        const order = Array.isArray(orders) && orders.length > 0 ? orders[0] : {};
        const { orderStatusId } = order;
        if (orderStatusId === 9) {
          setErrorOrderFlag(true);
        }
      }
    }
  };

  //returns modified notification object
  const getModifiedNotification = notification => {
    return {
      ...notification,
      notificationId: notification.id,
    };
  };

  const onUpdateNotification = notificationId => {
    const copiedNotifications = [...newNotifications.current];
    const nIndex = copiedNotifications.findIndex(n => n?.value?.notificationId === notificationId);
    if (nIndex !== -1)
      copiedNotifications.splice(nIndex, 1);
    setNewNotifications(copiedNotifications);
  };

  const getOrderTypeName = (id) => {
    const { orderTypes } = storeInfo || {};
    const orderTypeDetails = orderTypes.find(
      (each) => each.id === id
    );
    if (orderTypeDetails) {
      return orderTypeDetails.name;
    }
    return "";
  };

  const getRevenueCenterName = (id) => {
    const { revenueCenters } = storeInfo || {};
    const revenueCenterDetails = revenueCenters.find(
      (each) => each.id === id
    );
    if (revenueCenterDetails) {
      return revenueCenterDetails.name;
    }
    return "";
  };

  const emitSyncLogs = (logLevel, logMessage) => {
    if (window.ReactNativeWebView) {
      EventEmitter.addLogs('syncLogs', logLevel, logMessage);
    }
  };

  const checkAndApplyMDMPolicy = () => {
    const { mounted } = componentState;
    if (mounted && mdmPolicyNotification && !startMDMTimer) {
      setStartMDMTimer(true);
      setPopup({ type: 'mdm' });
    }
  };

  const acknowledgeNotification = callback => {
    const { id: storeId } = storeInfo || {};
    const { deviceId } = deviceApi || {};
    const payload = {
      deviceId,
      storeId,
      notificationId: notificationToBeAck?.notificationId,
    };
    if (window.ReactNativeWebView) {
      getPopup('spinner', 'Closing App...', '', null);
    }
    API.acknowledgeNotification(payload)
      .then(response => {
        callback && callback();
      }).catch(error => {
        callback && callback();
      });
    setNotificationToBeAck(null);
  };

  const resetMdmPolicyNotification = () => {
    setMdmPolicyNotification(undefined);
    setPopup(undefined);
  };

  const closeApp = (exit = false) => {
    const callback = () => {
      if (window.ReactNativeWebView && exit) {
        EventEmitter.restartApp();
      } else {
        resetMdmPolicyNotification();
        setStartMDMTimer(false);
      }
    };
    acknowledgeNotification(callback);
  };

  const print = check => {
    const { sourceType } = check;
    const { deviceTypeId, serverAppFeatures } = storeInfo || {};
    const { onlyAutoPrintOffPremiseChecks = false } = serverAppFeatures || {};
    const { printGuestReceipt = true, printKitchenTicket = true, printFullOrder = true } = checkSettingsRef.current;
    let { fbDisableAutoPrinting = false } = checkSettingsRef.current;

    //if device group data is not null then override value of "fbDisableAutoPrinting" with "deviceGroup.fireBoardSettings.enableAutoPrinting" value
    const { deviceGroup } = deviceApi || {};
    if (!FireboardUtils.isObjectBlank(deviceGroup)) {
      fbDisableAutoPrinting = !deviceGroup?.fireBoardSettings?.enableAutoPrinting;
    }

    if (defaultDeviceTypeId === 13 || deviceTypeId === 13) {
      if (printGuestReceipt)
        printGuestReceipts(check);
      if (printKitchenTicket)
        printKitchenTickets(check);
      if (printFullOrder)
        printFullOrderLabel(check);
    } else if ((defaultDeviceTypeId === 15 || deviceTypeId === 15) && !fbDisableAutoPrinting && (!onlyAutoPrintOffPremiseChecks || (onlyAutoPrintOffPremiseChecks && sourceType !== 0))) {
      const { guestAppFeatures } = storeInfo || {};
      const { autoPrintGuestReceiptOnSend, autoPrintKitchenTicketOnSend, autoPrintPackingLabelOnSend } = guestAppFeatures;
      if (autoPrintGuestReceiptOnSend) {
        printGuestReceipts(check);
      }
      if (autoPrintKitchenTicketOnSend) {
        printKitchenTickets(check);
      }
      if (autoPrintPackingLabelOnSend) {
        printFullOrderLabel(check);
      }
    }
  };

  const printAllKitchenTicket = (printData, check, printType) => {
    const { printJobs } = printData || {};
    if (Array.isArray(printJobs) && printJobs.length > 0) {
      const len = printJobs.length;
      let status = true, count = 0;
      setPopup(undefined);
      printJobs.forEach(data => {
        const { printerIpAddress, printerName, bytes } = data;
        const logData = {
          checkId: check.id,
          checkNumber: check.number,
          printerName: printerName,
          printerIpAddress: printerIpAddress,
          printType: printType,
        };
        if (bytes) {
          UTILLib.printReceipt(
            {
              data,
              type: "print",
              printType,
            },
            () => {
              count++;
              status = status && true;
              if (count === len) {
                if (status) {
                  const printTime = FireboardUtils.getTimeInHrsMins(new Date().toISOString());
                  savePrintStatus(check, 'Print Completed', data?.printerName, printTime);
                  addPrintLog({ ...logData, status: 'SUCCESS' });
                } else {
                  savePrintStatus(check, 'Print Failed', data?.printerName);
                  addPrintLog({ ...logData, status: 'FAILURE' });
                }
              }
            },
            error => {
              count++;
              status = status && false;
              if (count === len) {
                savePrintStatus(check, 'Print Failed', data?.printerName);
                addPrintLog({ ...logData, status: 'FAILURE' });
              }
            },
            () => {
              let popup = getPopupConfig('error', () => setPopup(undefined));
              popup.message = constants.extensionNotAvailable;
              setPopup(popup);
              addPrintLog({ ...logData, status: 'EXTENSION NOT AVAILABLE' });
            },
          );
        } else {
          addPrintLog({ ...logData, status: 'SKIPPING PRINT CALL' });
        }
      });
    } else {
      addPrintLog({
        checkId: check.id,
        checkNumber: check.number,
        printerName: null,
        printerIpAddress: null,
        printType: printType,
        status: 'SKIPPING PRINT CALL',
      });
    }
  };

  const printKitchenTickets = (check) => {
    const { deviceId } = deviceApi || {};
    const requestBody = {
      storeId: check.storeId,
      deviceId: deviceId,
      checkHeaderId: check.id,
    };
    API.printOrderTicket(requestBody)
      .then(response => {
        printAllKitchenTicket(response.data, check, 'Kitchen Ticket');
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        console.warn('error from print server', error, error.response);
        const errorMsg = error.response ? error.response.data.message : error.message;
        dispatchServerAppLogs(LogLevelEnum.ERROR, errorMsg);
        FireboardUtils.addNetworkLogs(error.response);
      });
  };

  const printGuestReceipts = check => {
    const { deviceId } = deviceApi || {};
    const requestBody = {
      storeId: check.storeId,
      deviceId: deviceId,
      employeeId: 0,
      checkHeaderId: check.id,
      seatIds: [],
      employeeCard: null,
    };
    API.tableReceiptPrint(requestBody)
      .then(response => {
        printReceipt(response, check, 'Guest Receipt');
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        console.warn('error from print server', error, error.response);
        const errorMsg = error.response ? error.response.data.message : error.message;
        dispatchServerAppLogs(LogLevelEnum.ERROR, errorMsg);
        FireboardUtils.addNetworkLogs(error.response);
      });
  };

  const printFullOrderLabel = check => {
    const { deviceId } = deviceApi || {};
    const requestBody = {
      storeId: check.storeId,
      deviceId: deviceId,
      checkHeaderId: check.id,
      includeItems: true,
    };
    API.printCheck(requestBody)
      .then(response => {
        printReceipt(response, check, 'Order + Items');
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => {
        console.warn('error from print server', error, error.response);
        const errorMsg = error.response ? error.response.data.message : error.message;
        dispatchServerAppLogs(LogLevelEnum.ERROR, errorMsg);
        FireboardUtils.addNetworkLogs(error.response);
      });
  };

  const printReceipt = (response, check, printType) => {
    const { printerIpAddress, printerName, bytes } = response?.data || {};
    const logData = {
      checkId: check.id,
      checkNumber: check.number,
      printerName: printerName,
      printerIpAddress: printerIpAddress,
      printType: printType,
    };
    if (bytes) {
      UTILLib.printReceipt(
        {
          data: response.data,
          type: "print",
          printType,
        },
        () => {
          setPopup(undefined);
          const printTime = FireboardUtils.getTimeInHrsMins(new Date().toISOString());
          savePrintStatus(check, 'Print Completed', printerName, printTime);
          addPrintLog({ ...logData, status: 'SUCCESS' });
        },
        error => {
          console.warn('error while printing receipt', error);
          savePrintStatus(check, 'Print Failed', printerName);
          addPrintLog({ ...logData, status: 'FAILURE' });
        },
        () => {
          let popup = getPopupConfig('error', () => setPopup(undefined));
          popup.message = constants.extensionNotAvailable;
          setPopup(popup);
          addPrintLog({ ...logData, status: 'EXTENSION NOT AVAILABLE' });
        },
      );
      setTimeout(() => {
        setPopup(undefined);
      }, 4000);
    } else {
      addPrintLog({ ...logData, status: 'SKIPPING PRINT CALL' });
    }
  };

  const savePrintStatus = (check, printStatus, printerName, printTime) => {
    const copiedChecks = new Map(checks.current);
    copiedChecks.set(check.id, {
      ...check,
      printStatus: check.printStatus && check.printStatus === 'Print Failed' ? 'Print Failed' : printStatus,
      printerName,
      printTime,
    });
    setChecks(copiedChecks);
  };

  const addPrintLog = logData => {
    const { checkId, checkNumber, printerName, printerIpAddress, printType, status } = logData || {};
    const { deviceTypeId } = storeInfo || {};
    if (defaultDeviceTypeId === 13 || deviceTypeId === 13) {
      const log = `#${checkNumber} | ${printerName || '--'} | ${printerIpAddress || '--'} | ${status}`;
      dispatch(addPrintLogAction(log));
    }
    EventEmitter.addLogs(
      'appLogs',
      LogLevelEnum.INFO,
      `AUTO PRINT - ${moment(new Date).format('YYYY-MM-DD hh:mm:ss')} | Check Id - ${checkId} | Check number - ${checkNumber} | Print Type - ${printType} | Printer Name - ${printerName} | Printer IP Address - ${printerIpAddress} | Print Status - ${status}`
    );
  };

  const setTblDeliveryMounted = () => {
    setIsTblDeliveryMounted(true);
  };

  const resetErrorOrderFlag = () => {
    setErrorOrderFlag(false);
  };

  const clearNewCheck = (checkHeaderId) => {
    const copiedNewChecks = new Map(newChecks.current);
    copiedNewChecks.delete(checkHeaderId);
    setNewChecks(copiedNewChecks);
  };

  const getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          setPopup(undefined);
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    setPopup(popup);
  };

  const onClose = () => {
    setPopup(undefined);
    if (window.ReactNativeWebView) {
      EventEmitter.playAudio(false);
    }
    acknowledgeNotification();
  };

  const getPopupStyle = () => {
    let popupStyle = { width: '32%' };
    if (popup && popup.type === 'spinner') {
      popupStyle = { width: '50%' };
    }
    return popupStyle;
  };

  const getPopupContent = () => {
    if (!popup) return null;
    switch (popup.type) {
      case 'mdm': {
        return <MdmPopup startTimer={startMDMTimer} closeApp={closeApp} />
      }
      case 'device': {
        return <DevicePopup onClose={onClose} deviceName={deviceApi?.deviceName} note={popup?.metaData?.note} />;
      }
      default: return <PopupContent {...popup} />;
    }
  };

  return (
    <React.Fragment>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        {getPopupContent()}
      </Popup>
      <SocketProvider
        value={{
          checks: checks.current,
          newChecks: newChecks.current,
          newNotifications: newNotifications.current,
          bookings: bookings.current,
          multipleStores: multipleStores.current,
          fbVenueMode: fbVenueMode.current,
          venueName: venueInfo.current?.name,
          errorOrderFlag: errorOrderFlag,
          isTblDeliveryMounted: isTblDeliveryMounted,
          updateNotification: onUpdateNotification,
          acknowledgeCheck: acknowledgeCheck,
          resetErrorOrderFlag: resetErrorOrderFlag,
          setDeviceType, setDeviceType,
          setTblDeliveryMounted, setTblDeliveryMounted,
          updateCheck: updateCheck,
          getStoreChecksCApi: getStoreChecksCApi,
          getVenueChecksCApi: getVenueChecksCApi,
          getStoreNotificationsCApi: getStoreNotificationsCApi,
          getStoreBookingsCApi: getStoreBookingsCApi,
          setIsDashboardMounted: setIsDashboardMounted,
          clearNewCheck: clearNewCheck,
        }}
      >
        {props.children}
      </SocketProvider>
    </React.Fragment>
  );
};

export default SocketContextComponent;
